import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import WeiboCircleFilledSvg from "@ant-design/icons-svg/es/asn/WeiboCircleFilled";
import AntdIcon from "../components/AntdIcon";
var WeiboCircleFilled = function WeiboCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: WeiboCircleFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  WeiboCircleFilled.displayName = 'WeiboCircleFilled';
}
export default /*#__PURE__*/React.forwardRef(WeiboCircleFilled);